import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PrimaryTable from '../../helpers/primary-table'
import ReactLoading from 'react-loading';
import { catchError } from '../../helpers/catch-error'
import InputAuto from '../../helpers/input-auto';
import { CSVLink } from "react-csv";



const AverageCost = () => {
    const params = useParams();
    const navigate = useNavigate();
    let d = new Date();
        const formatted_today = (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getDate().toString().padStart(2, "0") + '/' +  d.getFullYear();
        d.setDate(d.getDate() - 30);
        const formatted_thirty_days_ago = (d.getMonth() + 1).toString().padStart(2, "0") + '/' + d.getDate().toString().padStart(2, "0") + '/' +  d.getFullYear();
        const [woSearch, setWoSearch] = useState({
            start_date:formatted_thirty_days_ago,
            end_date:formatted_today 
    
        });
        
    const [workOrders, setWorkOrders] = React.useState(null);
    const [isLoading, setIsLoading] = useState(false);
        const [inputError, setInputError] = useState(false);
    
    const [facility, setFacility] = useState({
        facility_id: params.facility_id,
    });
    const [facilitiesNames, setFacilitiesNames] = useState([])
    const [csvHeader, setCsvHeader] = React.useState([
        { label: "DATE RANGE", key: "date_range"},
        { label: "FACILITY NAME", key: "facility_name"},
        { label: "TOTAL NUMBER OF CASES COMPLETED", key: "count_cases"},
        { label: "TOTAL COST OF ALL COMPLETED CASES", key: "total_cost"},
        { label: "AVG COST FOR THIS CLIENT", key: "avg_cost"},
       
      ]);



    var columns = React.useMemo(
        () => [
            {
                accessorKey: "date_range",
                header: "DATE RANGE",
                footer: props => props.column.id
            },
            {
                accessorFn: row => row.facility_name?row.facility_name + "_" + row.facility_city + " "+ row.facility_state:"",
                id: "facility",
                cell: ({ getValue }) => (
                    <span>
                        <ul className="table-ul">
                            {(getValue().split("_")).map((p, index) => (
                                <li key={index}>{p}</li>
                            ))}
                        </ul>
                    </span>
                ),
                header: () => "FACILITY",
                footer: props => props.column.id
            },
            {
                accessorKey: "count_cases",
                header: "TOTAL NUMBER OF CASES COMPLETED",
                footer: props => props.column.id
            },
            {
                accessorKey: "total_cost",
                header: "TOTAL COST OF ALL COMPLETED CASES",
                footer: props => props.column.id
            },
            {
                accessorKey: "avg_cost",
                header: "AVG COST FOR THIS CLIENT",
                footer: props => props.column.id
            },
           
          
        ],
        []
    )

    useEffect(() => {

        getFacilitiesNames();
        searchWorkOrders();
       

    }, []);



        const getFacilitiesNames = async (e) => {
    
    
            axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-facilities-names", {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(function (response) {
    
                if (response?.data?.status) {
    
                    setFacilitiesNames(response?.data?.facilities);
    
                } else {
    
                    Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });
    
                }
            }).catch(function (error) {
    
                catchError(error, navigate)
    
            });
    
        }
    
    




    const searchWorkOrders = () => {

          setInputError(false);
        if(!woSearch?.start_date || !woSearch?.end_date){
            setInputError(true);
            return false; 
        }
        setIsLoading(true);
        var search_elements = {}

        search_elements.start_date = woSearch?.start_date;
        search_elements.end_date = woSearch?.end_date;
        search_elements.facility_name = woSearch?.facility_name;
        search_elements.case_manager_first_name = woSearch?.case_manager_first_name;
        search_elements.report_type = 2

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-report-cost", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                
 let res_tmp =response?.data?.work_orders?.map(o => ({ ...o,
                     total_cost: `$${parseFloat(o.total_cost).toFixed(2)}`,
                    avg_cost: `$${parseFloat(o.avg_cost).toFixed(2)}`,
                     }));

                setWorkOrders(res_tmp);

            }
            else {

                setWorkOrders(null);

            }
            setIsLoading(false);


        }).catch(function (error) {

            // setIsBtn(false);
            catchError(error, navigate)

        });


    }


    return (
        <>

            <div className="row pb-2 mt-4">
                <div className="col-md-12 col-sm-12 ps-3 ">
                    <h3 className="text-dark my-0">AVERAGE COST PER FACILITY</h3>
                </div>


            </div>

            <div className="card card-form card-primary mt-4 pb-2">
                <div className="card-body">
                    <form className="form-horizontal form-thick mb-2"  >

                        <div className="row px-3 gx-3">


                           
                            <div className="col-3 my-1">
                                <label htmlFor="invoice_date_range">START DATE</label>

                                <DatePicker name="start_date" id="start_date" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsStart
                                    isClearable={true}
                                    selected={woSearch?.start_date}
                                    onChange={(e) => {
                                        {
                                            var dt = new Date(e);
                      
                                            const year = dt.getFullYear();
                                            const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                            const day = dt.getDate().toString().padStart(2, "0");
                          
                                            const formatted_date = month + '/' + day + '/' + year
                          
                                            setWoSearch({ ...woSearch, start_date: formatted_date })
                                           
                                          }
                                    }
                                    }
                                />
                                {inputError && !woSearch?.start_date && (
                                       <span className="text-danger">Enter valid start date</span>
                                )}
                            </div>
                            <div className="col-3 my-1">
                                <label htmlFor="invoice_date_range">END DATE</label>

                                <DatePicker name="end_date" id="end_date" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selectsEnd
                                    isClearable={true}
                                    selected={woSearch?.end_date}
                                    onChange={(e) => {
                                        {
                                            var dt = new Date(e);
                      
                                            const year = dt.getFullYear();
                                            const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                            const day = dt.getDate().toString().padStart(2, "0");
                          
                                            const formatted_date = month + '/' + day + '/' + year
                          
                                            setWoSearch({ ...woSearch, end_date: formatted_date })
                                           
                                          }
                                    }
                                    }
                                />
                                {inputError && !woSearch?.end_date && (
                                       <span className="text-danger">Enter valid end date</span>
                                )}
                            </div>

                            <div className="col-3 my-1">
                                <label htmlFor="client_id" >FACILITY</label>


                                <InputAuto name="facility_name" className="form-control" minStart="3"
                                    value={woSearch?.facility_name}
                                    pholder=""
                                    data={facilitiesNames}
                                    field="facility_name"
                                    onChange={(e) =>
                                        setWoSearch({ ...woSearch, facility_name: e })
                                    }
                                    onSelected={(e) => {
                                        setWoSearch({ ...woSearch, facility_name: e.facility_name })

                                    }
                                    }

                                />


                            </div>


                        
                        <div className="col-3 my-1">
                                <label htmlFor="client_id" >CASE MANAGER</label>


                        <input name="case_manager_first_name" className="form-control" type="text"
                            value={woSearch?.case_manager_first_name}
                            onChange={(e) =>
                                setWoSearch({ ...woSearch, case_manager_first_name: e.target.value })
                            }
                           

                        />
  </div>



                

            </div>


        </form >

                </div >

    <div className="card-footer">
        <div className="row">
            <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                <button onClick={() => searchWorkOrders()} className="btn btn-success mx-1" type="button" disabled={isLoading?true:false} >{isLoading?<><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></>:"GENERATE"} </button>
             
                {workOrders &&
              <CSVLink data={workOrders} headers={csvHeader} className="btn btn-warning mx-1" >DOWNLOAD</CSVLink>
}
<button onClick={() => { setWoSearch(null) }} className="btn btn-danger mx-1" type="button">CLEAR </button>
            
            </div>

        </div>
    </div>
            </div >




    {(workOrders || isLoading) &&

    <div className="card card-form card-primary mt-4 " >
        <div className="card-body p-0 mb-0" >

            {isLoading ?
                <div className="loader">
                    <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />
                </div>
                :
                <PrimaryTable columns={columns} data={workOrders} canFilter={false} />
            }


        </div>
    </div>

            }


        </>


    );
};

export default AverageCost;